import {listCarouselSizes} from '@adv-mt/mt-list-carousel'
export const CURRENT_YEAR = new Date().getFullYear()
export const SIZES = {...listCarouselSizes}
export const TITLE_POSITIONS = {
  LEFT: 'left',
  CENTER: 'center'
}
